import type { IFileProcessingStatus } from '@/apiClient/types/fileProcessingStatus'
import { UPLOADED_FILE_IN_PROGRESS_STATUSES } from '@/apiClient/types/fileProcessingStatus'

const IN_PROGRESS = new Set<string>(UPLOADED_FILE_IN_PROGRESS_STATUSES)

export function isUploadedFileStatusInProgress(
  status: IFileProcessingStatus,
): boolean {
  return IN_PROGRESS.has(status)
}
